(function () {
  let CURRENT_OPEN_CARD = null;

  function formatMoney(cents) {
    const fmt = (window.Shopify && Shopify.money_format) || "${{amount}}";
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, fmt);
    }
    const amount = (Number(cents) / 100).toFixed(2);
    return fmt
      .replace("{{amount}}", amount)
      .replace("{{ amount }}", amount)
      .replace("{{amount_with_comma_separator}}", amount.replace(".", ","))
      .replace("{{ amount_with_comma_separator }}", amount.replace(".", ","))
      .replace("{{amount_no_decimals}}", String(Math.round(Number(cents) / 100)))
      .replace("{{ amount_no_decimals }}", String(Math.round(Number(cents) / 100)));
  }

  function resetCardPrice(card){
  const el = card.querySelector("[data-price-value]");
  if (!el) return;

  const def = el.dataset.defaultPrice;
  if (def) el.textContent = def;
}

  function closestCard(el) {
    const direct = el.closest(".product-card");
    if (direct) return direct;

    const pop = el.closest(".pcard-variant-popover");
    if (pop && pop.__card) return pop.__card;

    return null;
  }

  function storeDefaultPrice(card){
  const el = card.querySelector("[data-price-value]");
  if (!el) return;

  if (!el.dataset.defaultPrice){
    el.dataset.defaultPrice = el.textContent.trim();
  }
}

  function getOpenPopoverForCard(card) {
    // If it has been portalized, it lives in <body> and has __card
    const portalized = document.querySelectorAll(".pcard-variant-popover[data-portalized='1']");
    for (const p of portalized) if (p.__card === card) return p;
    return card.querySelector(".pcard-variant-popover");
  }

  function portalPopoverToBody(card) {
    const pop = card.querySelector(".pcard-variant-popover");
    const trigger = card.querySelector(".pcard-variant-trigger");
    if (!pop || !trigger) return;

    pop.__card = card;

    if (!pop.dataset.portalized) {
      pop.__origParent = pop.parentNode;
      pop.__origNext = pop.nextSibling;
      pop.dataset.portalized = "1";
    }

    if (pop.parentNode !== document.body) document.body.appendChild(pop);

    // Position relative to trigger (absolute so it scrolls with page)
    const r = trigger.getBoundingClientRect();
    const gap = -45; // your “move menu up a bit”

    pop.style.position = "absolute";
    pop.style.left = `${Math.round(r.left + window.scrollX)}px`;
    pop.style.top = `${Math.round(r.bottom + window.scrollY + gap)}px`;
    pop.style.width = `${Math.round(r.width)}px`;
    pop.style.zIndex = "99999";

    const inner = pop.querySelector(".pcard-variant-popover__inner");
    if (inner) inner.style.position = "static";
  }

  function unportalPopover(pop) {
    if (!pop || !pop.dataset.portalized) return;

    if (pop.__origParent) {
      if (pop.__origNext) pop.__origParent.insertBefore(pop, pop.__origNext);
      else pop.__origParent.appendChild(pop);
    }

    pop.style.position = "";
    pop.style.left = "";
    pop.style.top = "";
    pop.style.width = "";
    pop.style.zIndex = "";
  }

  function closePopover(card) {
    const trigger = card.querySelector(".pcard-variant-trigger");
    const pop = getOpenPopoverForCard(card);
    if (!pop || !trigger) return;

    pop.hidden = true;
    trigger.setAttribute("aria-expanded", "false");

    resetCardPrice(card);

    unportalPopover(pop);
  }

  function closeCurrentPopover() {
    if (!CURRENT_OPEN_CARD) return;
    closePopover(CURRENT_OPEN_CARD);
    CURRENT_OPEN_CARD = null;
  }

  function bindCloseOnBestSellersSlideMove(card) {
    const root = card.closest("featured-collection");
    if (!root) return;

    const movingEl = root.querySelector(".featured-collection__items");
    if (!movingEl || movingEl.dataset.popObs === "1") return;

    movingEl.dataset.popObs = "1";

    const obs = new MutationObserver(() => {
      // Close if the slider moves
      closeCurrentPopover();
    });

    obs.observe(movingEl, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  function openPopover(card) {
    const pop = card.querySelector(".pcard-variant-popover");
    const trigger = card.querySelector(".pcard-variant-trigger");
    if (!pop || !trigger) return;

    // close any open popup first
    if (CURRENT_OPEN_CARD && CURRENT_OPEN_CARD !== card) closeCurrentPopover();

    CURRENT_OPEN_CARD = card;

    // IMPORTANT: set up “close on slider move”
    bindCloseOnBestSellersSlideMove(card);

    portalPopoverToBody(card);

    pop.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
  }

  function bindCloseOnFeaturedCollectionDrag(card) {
  const root = card.closest("featured-collection");
  if (!root) return;

  // Bind once per featured-collection instance
  if (root.dataset.pcardDragClose === "1") return;
  root.dataset.pcardDragClose = "1";

  let startX = 0;
  let startY = 0;
  let tracking = false;

  function onStart(e) {
    const t = e.touches ? e.touches[0] : e;
    startX = t.clientX;
    startY = t.clientY;
    tracking = true;
  }

  function onMove(e) {
    if (!tracking) return;
    if (!CURRENT_OPEN_CARD) return;

    const t = e.touches ? e.touches[0] : e;
    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    // Only close for a meaningful HORIZONTAL swipe (Best Sellers drag)
    if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
      closePopover(CURRENT_OPEN_CARD);
      CURRENT_OPEN_CARD = null;
      tracking = false;
    }
  }

  function onEnd() {
    tracking = false;
  }

  // Use capture so we see the gesture even if Swiper/Carousel handles it
  root.addEventListener("touchstart", onStart, { capture: true, passive: true });
  root.addEventListener("touchmove", onMove,   { capture: true, passive: true });
  root.addEventListener("touchend", onEnd,     { capture: true, passive: true });

  root.addEventListener("pointerdown", onStart, { capture: true });
  root.addEventListener("pointermove", onMove,  { capture: true });
  root.addEventListener("pointerup", onEnd,     { capture: true });
}

  function repositionCurrentPopover() {
    if (!CURRENT_OPEN_CARD) return;
    const pop = getOpenPopoverForCard(CURRENT_OPEN_CARD);
    if (!pop || pop.hidden) return;
    portalPopoverToBody(CURRENT_OPEN_CARD);
  }

  window.addEventListener("scroll", repositionCurrentPopover, { passive: true });
  window.addEventListener("resize", repositionCurrentPopover);

  // ---------- YOUR EXISTING VARIANT/OPTIONS FUNCTIONS ----------
  function buildOptionsUI(popover, options) {
    const container = popover.querySelector(".pcard-variant-popover__options");
    if (!container) return;
    container.innerHTML = "";

    options.forEach((opt, idx) => {
      const group = document.createElement("div");
      group.className = "pcard-variant-popover__group";
      group.dataset.optionIndex = String(idx);

      const label = document.createElement("div");
      label.className = "pcard-variant-popover__label";
      label.textContent = opt.name;

      const bubbles = document.createElement("div");
      bubbles.className = "pcard-variant-popover__bubbles";

      opt.values.forEach((val) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "pcard-variant-bubble";
        b.dataset.value = val;
        b.textContent = val;
        bubbles.appendChild(b);
      });

      group.appendChild(label);
      group.appendChild(bubbles);
      container.appendChild(group);
    });
  }

  function getFirstAvailableSelection(variants) {
    const first = variants.find((v) => v && v.available);
    return first ? first.options || [] : null;
  }

  function findMatchingVariant(variants, selectedValues) {
    return variants.find((v) => {
      const opts = v.options || [];
      for (let i = 0; i < selectedValues.length; i++) {
        if (!selectedValues[i]) return false;
        if ((opts[i] || "").toLowerCase() !== selectedValues[i].toLowerCase()) return false;
      }
      return true;
    });
  }

  function setSelectedBubble(groupEl, value) {
    groupEl.querySelectorAll(".pcard-variant-bubble").forEach((b) => {
      b.classList.toggle("is-selected", b.dataset.value === value);
    });
  }

  function getSelectedValues(popover) {
    const groups = [...popover.querySelectorAll(".pcard-variant-popover__group")];
    return groups.map((g) => {
      const selected = g.querySelector(".pcard-variant-bubble.is-selected");
      return selected ? selected.dataset.value : null;
    });
  }

  function updateBubbleAvailability(popover, variants, selectedValues) {
    const groups = [...popover.querySelectorAll(".pcard-variant-popover__group")];

    groups.forEach((group, groupIndex) => {
      const bubbles = [...group.querySelectorAll(".pcard-variant-bubble")];

      bubbles.forEach((bubble) => {
        const testValues = [...selectedValues];
        testValues[groupIndex] = bubble.dataset.value;

        const exists = variants.some((v) => {
          return (v.options || []).every((opt, i) => {
            if (!testValues[i]) return true;
            return String(opt).toLowerCase() === String(testValues[i]).toLowerCase();
          });
        });

        bubble.classList.toggle("is-disabled", !exists);
        bubble.disabled = !exists;
      });
    });
  }

function updateCardUI(card, variant, isCompleteSelection = false) {
  const priceValue = card.querySelector("[data-price-value]");
  if (priceValue && variant) priceValue.textContent = formatMoney(variant.price);

  const pop = getOpenPopoverForCard(card);
  const addBtn = pop ? pop.querySelector(".pcard-variant-add") : null;

  if (addBtn) {
    const canAdd = !!(isCompleteSelection && variant && variant.available);
    addBtn.disabled = !canAdd;
    addBtn.dataset.variantId = canAdd ? String(variant.id) : "";
  }
}

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  document.addEventListener("click", async (e) => {
    const trigger = e.target.closest(".pcard-variant-trigger");
    const bubble = e.target.closest(".pcard-variant-bubble");
    const closeBtn = e.target.closest(".pcard-variant-popover__close");
    const addBtn = e.target.closest(".pcard-variant-add");

    // open/toggle (and close any other)
    if (trigger) {
      const card = closestCard(trigger);
      if (!card) return;

      const pop = getOpenPopoverForCard(card);

      // toggle same card
      if (CURRENT_OPEN_CARD === card && pop && !pop.hidden) {
        closeCurrentPopover();
        return;
      }

      // build once
      if (pop && !pop.dataset.built) {
        const options = JSON.parse(trigger.dataset.options || "[]");
        const variants = JSON.parse(trigger.dataset.variants || "[]");

        buildOptionsUI(pop, options);

        const firstAvailable = getFirstAvailableSelection(variants);
        if (firstAvailable) {
          pop.querySelectorAll(".pcard-variant-popover__group").forEach((g, idx) => {
            const val = firstAvailable[idx];
            if (!val) return;
            const match = [...g.querySelectorAll(".pcard-variant-bubble")].find(
              (b) => String(b.dataset.value || "").toLowerCase() === String(val).toLowerCase()
            );
            if (match) match.classList.add("is-selected");
          });
        }
        
        pop.dataset.defaultSelection = JSON.stringify(getSelectedValues(pop));

        pop.dataset.built = "1";

        const selected = getSelectedValues(pop);
        updateBubbleAvailability(pop, variants, selected);

        const complete = selected.every(Boolean);
        const v = complete ? findMatchingVariant(variants, selected) : null;
        storeDefaultPrice(card);
        updateCardUI(card, v, complete);
      }

      bindCloseOnFeaturedCollectionDrag(card);

      // Reselect defaults on every open
const variants = JSON.parse(trigger.dataset.variants || "[]");

let defaults = null;
try { defaults = JSON.parse(pop.dataset.defaultSelection || "null"); } catch(e) {}

if (!defaults) {
  // fallback if somehow missing
  defaults = getFirstAvailableSelection(variants);
}

// apply defaults to bubbles
if (defaults) {
    pop.querySelectorAll(".pcard-variant-popover__group").forEach((g, idx) => {

      // 🔹 CLEAR any previous selection first
      g.querySelectorAll(".pcard-variant-bubble")
        .forEach(b => b.classList.remove("is-selected"));

      const val = defaults[idx];
      if (!val) return;

      const match = [...g.querySelectorAll(".pcard-variant-bubble")]
        .find(b => String(b.dataset.value || "").toLowerCase() === String(val).toLowerCase());

      if (match) match.classList.add("is-selected");
    });
}

const selected = getSelectedValues(pop);
updateBubbleAvailability(pop, variants, selected);

const complete = selected.every(Boolean);
const v = complete ? findMatchingVariant(variants, selected) : null;
updateCardUI(card, v, complete);

      openPopover(card);
      return;
    }

    if (closeBtn) {
      closeCurrentPopover();
      return;
    }

    if (bubble) {
      const card = closestCard(bubble);
      const pop = getOpenPopoverForCard(card);
      const triggerEl = card.querySelector(".pcard-variant-trigger");
      const variants = JSON.parse(triggerEl.dataset.variants || "[]");

      const group = bubble.closest(".pcard-variant-popover__group");
      setSelectedBubble(group, bubble.dataset.value);

      const selected = getSelectedValues(pop);
      updateBubbleAvailability(pop, variants, selected);

      const complete = selected.every(Boolean);
      const v = complete ? findMatchingVariant(variants, selected) : null;
      updateCardUI(card, v, complete);
      return;
    }

if (addBtn) {
  e.preventDefault();
  e.stopPropagation();

  const card = closestCard(addBtn);
  if (!card) return;

  const pop = getOpenPopoverForCard(card);
  const triggerEl = card.querySelector(".pcard-variant-trigger");
  const variants = JSON.parse(triggerEl?.dataset.variants || "[]");

  const selected = getSelectedValues(pop);
  const complete = selected.every(Boolean);
  const v = complete ? findMatchingVariant(variants, selected) : null;

  if (!v || !v.available) return;

  addBtn.disabled = true;

  try {
    await addToCart(v.id, 1); // ✅ always selected variant
    addBtn.querySelector(".btn__text").textContent = "Added";
  } catch (err) {
    addBtn.querySelector(".btn__text").textContent = "Error";
  } finally {
    setTimeout(() => { addBtn.disabled = false; }, 800);
  }
  return;
}

    // click outside closes
    if (CURRENT_OPEN_CARD) {
      const pop = getOpenPopoverForCard(CURRENT_OPEN_CARD);
      const triggerEl = CURRENT_OPEN_CARD.querySelector(".pcard-variant-trigger");
      const inner = pop && pop.querySelector(".pcard-variant-popover__inner");

      const clickedInside =
        (inner && inner.contains(e.target)) || (triggerEl && triggerEl.contains(e.target));

      if (!clickedInside) closeCurrentPopover();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCurrentPopover();
  });
})();